import React from 'react';
import imageUrl from 'assets/images/Sales_Order.png';
import { Typography } from '../../../node_modules/@mui/material/index';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { FABRICUSER, GARMENTUSER } from 'utils/constants';
import { getSampleRequestAccessAPI } from 'Service/ApiService';
// import { getBarcodeScanData } from 'Service/ApiService';
import { showAlert } from 'utils/ErrorMessage';


const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch (error) {
    return null;
  }
};

const REPORTS_PAYLOAD_KEY = "samplePlanningReportsPayload90Days";

// const customer = JSON.parse(localStorage.getItem('headerCustomer'));
const SampleRequest90daysDashboard = () => {
  const [isData, setIsData] = React.useState(false);
  const [isClick, setClick] = React.useState(false);
  const [designNumber, setDesignNumber] = React.useState('');
  const [designError, setDesignError] = React.useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const reportsPayload =
    location.state?.reportsPayload ||
    (() => {
      try {
        const raw = localStorage.getItem(REPORTS_PAYLOAD_KEY);
        return raw ? JSON.parse(raw) : {};
      } catch (e) {
        return {};
      }
    })();

  React.useEffect(() => {
    if (reportsPayload && typeof reportsPayload === "object") {
      localStorage.setItem(REPORTS_PAYLOAD_KEY, JSON.stringify(reportsPayload));
    }
  }, [reportsPayload]);
  // const handleDivClick = (value) => () => {
  //   if (value == 'design') {
  //     setClick(true);
  //   } else {
  //     sendNav();
  //   }
  // };
  const handleDivClick = (value) => async () => {
    const user = getStoredUser();
    const conference = (() => {
      try {
        return JSON.parse(localStorage.getItem('confvalue') || 'null');
      } catch (error) {
        return null;
      }
    })();

    if (!user || !conference?.cID) {
      showAlert('Conference or user session is unavailable. Please login again.');
      return;
    }

    const conferenceId = conference.cID;

    try {
      setIsData(true);

      const res = await getSampleRequestAccessAPI(user.userCode, conferenceId);

      if (res.success === "false") {
        showAlert(res.msg); // ❌ block both Design & Barcode
        return;
      }

      // ✅ Allowed cases
      if (value === 'design') {
        setClick(true); // open dialog only if allowed
      } else if (value === '/barcode-scan-sales-planning') {
        sendNav();
      }

    } catch (err) {
      console.error("Access check failed:", err);
      showAlert("Server error. Please try again later.");
    } finally {
      setIsData(false);
    }
  };


  const handleCloseDialog = () => {
    if (!isData) {
      setClick(false);
      setDesignNumber('');
      setDesignError('');
    }
  };

  const handleOk = () => {
    if (!designNumber.trim()) {
      setDesignError('Design Number is required');
      return;
    }
    setIsData(true);
    // navigate to sample-design page and pass designNumber via state
    navigate('/sample-design-sales-planning', {
      state: {
        designNumber: designNumber.trim(),
        reportsPayload
      }
    });
    // reset dialog state
    setIsData(false);
    setClick(false);
    setDesignNumber('');
    setDesignError('');
  };
  // const handleOk = async () => {
  //   if (!designNumber.trim()) {
  //     setDesignError('Design Number is required');
  //     return;
  //   }

  //   try {
  //     setIsData(true);
  //     const conferenceId = user.conferenceId;

  //     const res = await getSampleRequestAccessAPI(user.userCode, conferenceId);

  //     if (res.success === "false") {
  //       showAlert(res.msg); // block navigation and show message
  //       setIsData(false);
  //       return;
  //     }

  //     // Allowed — navigate to next page
  //     navigate('/sample-design-sales-planning', {
  //       state: { designNumber: designNumber.trim() }
  //     });

  //   } catch (err) {
  //     console.error("Error checking access:", err);
  //     showAlert("Server error. Please try again later.");
  //   } finally {
  //     // Reset dialog state
  //     setIsData(false);
  //     setClick(false);
  //     setDesignNumber('');
  //     setDesignError('');
  //   }
  // };

  const handleDivKeyPress = (value) => (event) => {
    if (event.key === 'Enter') {
      if (value == 'design') {
        setClick(true);
      } else {
        sendNav();
      }
    }
  };
  const sendNav = () => {
    const user = getStoredUser();
    if (!user) {
      showAlert('User session is unavailable. Please login again.');
      return;
    }

    if (user.userVerticalId == FABRICUSER) {
      navigate('/barcode-scan-sales-planning', { state: { reportsPayload } });
    } else if (user.userVerticalId.toLowerCase().includes(GARMENTUSER.toLowerCase())) {
      navigate('/barcode-scan-sales-planning', { state: { reportsPayload } });
    }
  };
  return (
    <div className="bg" style={{ display: 'block' }}>
      <div className="cutrange">
        <span className="font20">SALES PLANNING DASHBOARD</span>
      </div>

      <div>
        <div style={{ paddingBottom: '20px' }} className="horizontal-center">
          <div className="flexWrapper-d">
            <div
              style={{ width: '150px' }}
              className="card-subtitle"
              onClick={handleDivClick('design')}
              onKeyDown={handleDivKeyPress('design')}
              role="button"
              tabIndex={0}
            >
              <div style={{ padding: '10px' }} className="horizontal-center">
                <div>
                  <div className="horizontal-center">
                    <img src={imageUrl} alt="Design No Entry" style={{ width: 'auto' }} />
                  </div>
                  <Typography variant="subtitle1" style={{ marginTop: '10px' }}>
                    Design No Entry
                  </Typography>
                </div>
              </div>
            </div>
            <div
              style={{ width: '150px' }}
              className="card-subtitle"
              onClick={handleDivClick('/barcode-scan-sales-planning')}
              onKeyDown={handleDivKeyPress('/barcode-scan-sales-planning')}
              role="button"
              tabIndex={0}
            >
              <div style={{ padding: '10px' }} className="horizontal-center">
                <div>
                  <div className="horizontal-center">
                    <img src={imageUrl} alt="Barcode Scan" style={{ width: 'auto' }} />
                  </div>
                  <Typography variant="subtitle1" style={{ marginTop: '10px' }}>
                    Barcode Scan
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Design Number Dialog kept in this page */}
      <Dialog open={isClick} onClose={handleCloseDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Enter Design Number</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <TextField
              autoFocus
              fullWidth
              label="Design Number"
              variant="outlined"
              value={designNumber}
              onChange={(e) => { setDesignNumber(e.target.value); if (designError) setDesignError(''); }}
              onKeyDown={(e) => { if (e.key === 'Enter') handleOk(); }}
              helperText={designError}
              error={!!designError}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={isData}>Cancel</Button>
          <Button variant="contained" onClick={handleOk} disabled={isData}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SampleRequest90daysDashboard;
